import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getActivityPrediction';

export const getActivityPrediction = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
